import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { DYNASTIES } from "../../constants/leagueInfo";
import { TOILET_BOWLS } from "../../constants/playoffInfo";
import { League, NflState, Roster, User } from "../../models/_helper";
import { Loading } from "../../pages/_helper";
import { getUserByRosterId } from "../../services/_helper";

DynastySidebar.propTypes = {
  leagues: PropTypes.arrayOf(PropTypes.instanceOf(League)).isRequired,
  rosters: PropTypes.arrayOf(PropTypes.instanceOf(Roster)).isRequired,
  users: PropTypes.arrayOf(PropTypes.instanceOf(User)).isRequired,
  nfl_state: PropTypes.instanceOf(NflState),
};
export default function DynastySidebar({ leagues, rosters, users, nfl_state }) {
  const [reigningChamp, setReigningChamp] = useState(null);
  const [reigningLoser, setReigningLoser] = useState(null);

  useEffect(() => {
    function getReigningChamp() {
      setReigningChamp(
        getUserByRosterId(
          leagues[1].metadata.latest_league_winner_roster_id,
          rosters,
          users
        )
      );
    }
    function getReigningLoser() {
      const prevSeason = leagues[1].season;
      TOILET_BOWLS.forEach((toilet_bowl) => {
        if (toilet_bowl.season === prevSeason) {
          setReigningLoser(toilet_bowl.owner);
        }
      });
    }
    getReigningChamp();
    getReigningLoser();
  }, [leagues, rosters, users]);

  if (reigningLoser !== null && reigningChamp !== null) {
    return (
      <div className="hidden md:flex md:flex-col md:justify-around md:items-center bg-dark pt-2 pb-4 border-0 border-secondary border-r-1 w-0 md:w-1/4 2xl:w-1/6 xl:w-1/5 h-full">
        <div className="flex flex-col px-6 pb-2 w-full text-secondary text-center">
          <p className="leading-5 2xl:leading-6">REIGNING DYNASTY CHAMPION:</p>
          <p className="mb-2 2xl:mb-3 text-primary">
            {DYNASTIES[DYNASTIES.length - 1].winner === null
              ? "N/A"
              : DYNASTIES[DYNASTIES.length - 1].winner}
          </p>

          <p className="leading-5 2xl:leading-6">
            {leagues[1].season} SEASON CHAMPION:
          </p>
          <p className="mb-2 2xl:mb-3 text-primary leading-5 2xl:leading-6">
            {reigningChamp.team_name}
          </p>

          <p className="leading-5 2xl:leading-6">
            {leagues[1].season} TOILET BOWL LOSER:
          </p>
          <p className="mb-3 2xl:mb-4 text-primary capitalize">
            {reigningLoser.full_name}
          </p>

          <p className="mb-2 2xl:mb-3">
            LEAGUE:{" "}
            <span className="text-primary">
              YEAR {leagues[0].season - 2022}
            </span>
          </p>

          <p className="mb-2 2xl:mb-3">
            DYNASTY: <span className="text-primary">YEAR {leagues.length}</span>
          </p>

          <p className="mb-2 2xl:mb-3">
            SEASON: <span className="text-primary">{leagues[0].season}</span>
          </p>

          <p>
            CURRENT WEEK:{" "}
            <span className="text-primary">
              {nfl_state.week === 0 ? 1 : nfl_state.week}
            </span>
          </p>
        </div>

        <hr className="border-secondary w-full" />

        <div className="flex flex-col justify-start overflow-hidden">
          <img
            src="/img/logo.png"
            alt="ORDER 41"
            className="mx-auto w-3/5"
            width={"100%"}
          />
          <div className="px-6 pt-2 lg:pt-2 2xl:pt-6 xl:pt-2 text-light text-center">
            <p className="text-xs xl:text-xs lg:text-sm 2xl:text-sm">
              ORDER 41 is a fantasy football dynasty league consisting of{" "}
              <NavLink to="/teams" className="hover:underline">
                six (6) men
              </NavLink>{" "}
              founded in 2023.
            </p>
          </div>
        </div>
        {/* STANDINGS */}
        {/* TOP SCORERS */}
      </div>
    );
  }
  return <Loading />;
}
